module.exports = __webpack_public_path__ + "img/mars-and-venus.c2976c59.svg";